module.exports = __webpack_public_path__ + "img/hpbd-text.3ccfcee1.svg";